import axios from "axios";
import authService from "./auth-service";

export interface WerkLookup {
  id: string;
  name: string;
}

class WerkService {
  public async getActiveWerks(): Promise<WerkLookup[]> {
    const authorization = await authService.getAuthHeader();
    const response = await axios.get<WerkLookup[]>("/api/werks", {
      headers: { Authorization: authorization },
    });
    return response.data;
  }

  public async getCarJockeyLocations(werkId: string): Promise<WerkLookup[]> {
    const authorization = await authService.getAuthHeader();
    const response = await axios.get<WerkLookup[]>(
      `/api/werks/${encodeURIComponent(werkId)}/carjokey-locations`,
      { headers: { Authorization: authorization } }
    );
    return response.data;
  }
}

export default new WerkService();
